import { Components, Theme } from '@mui/material';

const muiTablePagination: Components<Theme>['MuiTablePagination'] = {
	styleOverrides: {
		caption: ({ theme }) => ({
			...theme.typography.pagination,
		}),
		input: ({ theme }) => ({
			...theme.typography.pagination,
		}),
	},
};

export default muiTablePagination;
